import { IUncommonFontLogic, OnUncommonFontLoadedCallback } from '@src/slide/content-viewer/service/font-manager/core/font-manager.interface';

export const UncommonFontFamily = 'TdocsUncommon';

const UncommonFontUnicodeRange = `U+9FA6-9FEF, U+FA0F,U+FA11,U+FA13-FA14,U+FA1F,U+FA21,U+FA23-FA24,U+FA27-FA29,U+20087,
U+20089,U+200CC,U+20164,U+20676,U+20CD0,U+2139A,U+21413,U+215D7,U+2298F,U+235CB,U+23C97-23C98,U+23E23,U+241FE,
U+249DB,U+24A7D,U+24AC9,U+25532,U+25562,U+255A8,U+25ED7,U+26221,U+2648D,U+26676,U+2677C,U+26B5C,U+26C21,U+27FF9,
U+28408,U+28678,U+28695,U+287E0,U+28B49,U+28C47,U+28C4F,U+28C51,U+28C54,U+28E99,U+29F7E,U+29F83,U+29F8C,U+2A7DD,
U+2A8FB,U+2A917,U+2AA30,U+2AA36,U+2AA58,U+2AFA2,U+2B127-2B128,U+2B137-2B138,U+2B1ED,U+2B300,U+2B363,U+2B36F,U+2B372,
U+2B37D,U+2B404,U+2B410,U+2B413,U+2B461,U+2B4E7,U+2B4EF,U+2B4F6,U+2B4F9,U+2B50D-2B50E,U+2B536,U+2B5AE-2B5AF,
U+2B5B3,U+2B5E7,U+2B5F4,U+2B61C-2B61D,U+2B626-2B628,U+2B62A,U+2B62C,U+2B695-2B696,U+2B6AD,U+2B6ED,U+2B7A9,
U+2B7C5,U+2B7E6,U+2B7F9,U+2B7FC,U+2B806,U+2B80A,U+2B81C,U+2B8B8,U+2BAC7,U+2BB5F,U+2BB62,U+2BB7C,U+2BB83,U+2BC1B,U+2BD77,
U+2BD87,U+2BDF7,U+2BE29,U+2C029-2C02A,U+2C0A9,U+2C0CA,U+2C1D5,U+2C1D9,U+2C1F9,U+2C27C,U+2C288,
U+2C2A4,U+2C317,U+2C35B,U+2C361,U+2C364,U+2C488,U+2C494,U+2C497,U+2C542,U+2C613,U+2C618,U+2C621,U+2C629,U+2C62B-2C62D,
U+2C62F,U+2C642,U+2C64A-2C64B,U+2C72C,U+2C72F,U+2C79F,U+2C7C1,U+2C7FD,U+2C8D9,U+2C8DE,U+2C8E1,U+2C8F3,U+2C907,U+2C90A,
U+2C91D,U+2CA02,U+2CA0E,U+2CA7D,U+2CAA9,U+2CB29,U+2CB2D-2CB2E,U+2CB31,U+2CB38-2CB39,U+2CB3B,U+2CB3F,U+2CB41,U+2CB4A,
U+2CB4E,U+2CB5A-2CB5B,U+2CB64,U+2CB69,U+2CB6C,U+2CB6F,U+2CB73,U+2CB76,U+2CB78,U+2CB7C,U+2CBB1,U+2CBBF-2CBC0,
U+2CBCE,U+2CC56,U+2CC5F,U+2CCF5-2CCF6,U+2CCFD,U+2CCFF,U+2CD02-2CD03,U+2CD0A,U+2CD8B,U+2CD8D,
U+2CD8F-2CD90,U+2CD9F-2CDA0,U+2CDA8,U+2CDAD-2CDAE,U+2CDD5,U+2CE18,U+2CE1A,U+2CE23,U+2CE26,U+2CE2A,U+2CE7C,U+2CE88,U+2CE93`;

export class UncommonFontLogic implements IUncommonFontLogic {
    private observers: Array<OnUncommonFontLoadedCallback>;

    public constructor() {
        this.observers = [];
        document.fonts?.addEventListener?.('loadingdone', this.onNewFontLoaded);
        this.checkFontReady();
    }

    public addObserverForUncommonFontLoaded(observer: OnUncommonFontLoadedCallback) {
        if (this.observers.indexOf(observer) < 0) {
            this.observers.push(observer);
        }
    }

    public removeObserverForUncommonFontLoaded(observer: OnUncommonFontLoadedCallback) {
        const index = this.observers.indexOf(observer);
        index >= 0 && this.observers.splice(index, 1);
    }

    private checkFontReady() {
        if (document.fonts?.status === undefined) return;
        if (document.fonts?.status === 'loading') {
            document.fonts?.ready.then((fonts) => {
                this.checkUncommonFonts(fonts);
            });
        } else {
            this.checkUncommonFonts(document.fonts);
        }
    }

    private getUncommonFontFace(fontFaceSet: FontFaceSet): FontFace | undefined {
        let uncommonFontFace: FontFace | undefined = undefined;
        fontFaceSet?.forEach((value) => {
            if (value.family === UncommonFontFamily) {
                uncommonFontFace = value;
            }
        });
        return uncommonFontFace;
    }

    private checkUncommonFonts(fontFaceSet: FontFaceSet) {
        const tdocsUncommonFontFace = this.getUncommonFontFace(fontFaceSet);
        if (tdocsUncommonFontFace) {
            if (tdocsUncommonFontFace.status === 'unloaded') {
                tdocsUncommonFontFace.load().then(() => {
                    this.notify(tdocsUncommonFontFace);
                });
            }
        } else {
            const fontFace = new FontFace(UncommonFontFamily, 'url(https://docs.gtimg.com/common-cdn/ttf/HYZhongHei-Subset.woff)', {
                display: 'swap',
                unicodeRange: UncommonFontUnicodeRange,
            });
            document.fonts?.add(fontFace);
            fontFace.load().then(() => {
                this.notify(fontFace);
            });
        }
    }

    private onNewFontLoaded = () => {
        const uncommonFontFace = this.getUncommonFontFace(document.fonts);
        if (!uncommonFontFace) return;
        if (uncommonFontFace.status === 'loaded') {
            this.notify(uncommonFontFace);
        }
    };

    private notify(uncommonFont: FontFace) {
        this.observers?.forEach(observer => observer?.(uncommonFont, UncommonFontFamily));
        document.fonts?.removeEventListener?.('loadingdone', this.onNewFontLoaded);
    }
}
